var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocksBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102%",
    viewBox: "0 0 1100 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: "relative",
      left: "-10px"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "blocks-bottom-a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1126,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h1126v44H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    mask: "url(#blocks-bottom-a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "blocks-bottom-b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -44,
    y: -18,
    width: 1194,
    height: 83
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 1150 65)",
    fill: "#C4C4C4",
    d: "M1150 65h1194v83H1150z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#blocks-bottom-b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M-17.426 26.104h173.14V-9.603h-173.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E26FAB",
    d: "M-1.516 13.792h289.19v-46.788H-1.516z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#254A5D",
    d: "M369.098 43.958h256.434V-2.83H369.098z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#AAD037",
    d: "M507.609 8.25h257.37v-46.787h-257.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M600.263 28.567h237.716v-43.094H600.263z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#715477",
    d: "M764.979 37.801h203.088V.863H764.979z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#647559",
    d: "M677.006 7.02h302.293v-54.791H677.006z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FED000",
    d: "M923.146 18.101h200.281V-18.22H923.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAD037",
    d: "M142.611 34.723h173.14V-.984h-173.14z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#DA3336",
    d: "M153.842 20.578H477.66v-67.105H153.842z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksBottom);
export default __webpack_public_path__ + "static/media/blocks-bottom.3bf72c46.svg";
export { ForwardRef as ReactComponent };